import { QueryClient } from '@tanstack/react-query';

// Desk data changes when the pipeline writes (signalled by freshness
// sidecars), not on window focus — explicit invalidation only. A 4xx means a
// missing object: raise loudly, never retry into it.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 30 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, error) =>
        !(error instanceof Error && /API call failed: 4\d\d/.test(error.message)) &&
        failureCount < 1,
    },
  },
});
